import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=2d56972c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=2d56972c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d56972c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d56972c')) {
      api.createRecord('2d56972c', component.options)
    } else {
      api.reload('2d56972c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=2d56972c&scoped=true&", function () {
      api.rerender('2d56972c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W11z5WKS4bCC/JS/comp/PopupDialog.vue"
export default component.exports